import { c as _c } from "react/compiler-runtime";
import { Tooltip } from '@mantine/core';
import { isNumber } from 'remeda';
import { Fmt } from 'shared/forecast';
import { StyleProps } from 'shared/ui/uiType';
export const ForecastMark = t0 => {
  const $ = _c(2);
  const {
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = <div className="h-6 w-6 rounded-full border-2 border-dashed " style={{
      borderColor: color
    }} />;
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const textStrokeStyle = {
  textShadow: '-2px -2px 0 #FFF, 2px -2px 0 #FFF, -2px 2px 0 #FFF, 2px 2px 0 #FFF'
};
export const ForecastMarkLabel = t0 => {
  const $ = _c(7);
  const {
    value,
    color,
    label,
    className,
    hideNumber,
    location
  } = t0;
  let t1;
  if ($[0] !== className || $[1] !== color || $[2] !== hideNumber || $[3] !== label || $[4] !== location || $[5] !== value) {
    t1 = value != null ? <div className={`rounded-lg text-center ${className ?? ""}`}>{!hideNumber && <p className="text-xl font-bold " style={{
        color,
        ...textStrokeStyle,
        ...(location == "bottom" ? {
          marginTop: "0.5rem"
        } : {})
      }}>{isNumber(value) ? Fmt.fmt(value) : value}</p>}<p className="mt-[-0.4em]" style={textStrokeStyle}>{label}</p></div> : <></>;
    $[0] = className;
    $[1] = color;
    $[2] = hideNumber;
    $[3] = label;
    $[4] = location;
    $[5] = value;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};
export const ForecastMarkLine = t0 => {
  const $ = _c(9);
  const {
    color,
    location: t1,
    label
  } = t0;
  const location = t1 === undefined ? "top" : t1;
  const t2 = location == "top" ? "top" : "bottom";
  const t3 = `absolute pointer-events-auto cursor-default ${location == "top" ? "-top-5 bottom-3" : "-bottom-5 top-3"} left-1/2 border-l-4 border-dotted`;
  let t4;
  if ($[0] !== color) {
    t4 = {
      borderColor: color
    };
    $[0] = color;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== t3 || $[3] !== t4) {
    t5 = <div className={t3} style={t4} />;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== label || $[6] !== t2 || $[7] !== t5) {
    t6 = <div className="relative h-4 "><Tooltip label={label} position={t2}>{t5}</Tooltip></div>;
    $[5] = label;
    $[6] = t2;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};